import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { NotificationsPageComponent } from './notifications-page.component';
import { UserNotificationsModule } from 'src/app/shared/user-notifications/user-notifications.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.notifications',
    url: '/notifications',
    component: NotificationsPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      searchObject: null,
      context: null
    }
  }
];

@NgModule({
  declarations: [NotificationsPageComponent],
  imports: [
    CommonModule,
    UserNotificationsModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [NotificationsPageComponent, UserNotificationsModule],
  entryComponents:[NotificationsPageComponent]
})
export class NotificationsPageModule { }
